import { useLanguage } from '../lib/i18n/LanguageContext';
import { websiteUrl } from '../lib/websiteUrl';

const mark = (
  <>
    <img className="brand-mark" src="/logo-ic.png" alt="" width={36} height={32} aria-hidden="true" />
    <span>IC Lueur Ai</span>
  </>
);

/**
 * Top-left product mark on auth screens. Links to the marketing site when
 * `PUBLIC_WEBSITE_HOST` is baked in (same rule as the signed-in shell brand);
 * otherwise stays a plain non-interactive mark in local `npm run dev`.
 */
export function AuthBrand() {
  const { dict } = useLanguage();
  const homeUrl = websiteUrl();

  if (homeUrl) {
    return (
      <a className="auth-brand" href={homeUrl} aria-label={dict.common.backToWebsite}>
        {mark}
      </a>
    );
  }

  return <div className="auth-brand">{mark}</div>;
}
